<div class="container mb-4">
  <div class="row justify-content-center">
    <h2 class="text-center mb-3">{{ 'byt_home_about_us' | translate }}</h2>
  </div>
</div>

<div class="container mb-5">
  <div class="row">
    <ng-container *ngFor="let tile of tiles">
      <a
        [href]="tile.url"
        class="col-xs-12 col-md-6 px-3 px-md-2 py-2"
        target="_blank">
        <div
          class="card text-center"
          style="background-position: bottom center"
          [defaultImage]="defaultImage"
          [lazyLoad]="tile.image">
          <div class="card-content px-4">
            <h2 class="card-title mb-4">
              {{ tile.title | translate }}
            </h2>
            <h3 class="card-title mb-4" *ngIf="tile.description">
              {{ tile.description | translate }}
            </h3>
            <a
              target="_blank"
              [href]="tile.url"
              class="btn btn-outline-white btn-small mb-4"
              >{{ 'byt_learnMore' | translate }}</a
            >
          </div>
        </div>
      </a>
    </ng-container>
  </div>
</div>
